import { InputForm } from "@/components/AddForm";
import { Button } from "@/uiCore";
import { useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { insertNewSheet } from "../api";
import { listToast, scrollToTop } from "@/utils";
import { showToast } from "@/redux/features/toast";

const AddSheet = () => {
  const [infos, setInfos] = useState({ code: "", title: "" });
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const permissionTool = useSelector(
    (state) => state.permission
  ).permissionTool;
  async function fetchDataSubmit(info) {
    const response = await insertNewSheet({ url: infos?.url });
    if (response) setLoading(false);
    if (response.data.status) {
      scrollToTop();
      // if (refreshObjects && refreshObjects[0]) {
      //   refreshObjects.forEach((d) => {
      //     if (typeof d === "function") {
      //       d((e) => {
      //         const status = e.status;
      //         const cb_status = e.cb_status;
      //         if (Array.isArray(e)) return [];
      //         else return { ...refreshObject(e), status, cb_status };
      //       });
      //     }
      //   });
      // }
      dispatch(
        showToast({ ...listToast[0], detail: `Thêm dữ liệu thành công!` })
      );
    } else dispatch(showToast({ ...listToast[1], detail: response.data.mess }));
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    // const info = handleData();
    if (typeof infos === "object") {
      fetchDataSubmit(infos);
    } else {
      dispatch(showToast({ ...listToast[1], detail: infos }));
      setLoading(false);
    }
  };

  return (
    <div>
      <form
        onSubmit={handleSubmit}
        className="card w-8"
        style={{ margin: "0 auto" }}
      >
        <h5 className="mb-4" style={{ textAlign: "center" }}>
          Thêm URL Google Sheet:{" "}
        </h5>
        <div className="card">
          <div className="w-9">
            <InputForm
              id="url"
              label="URL Sheet (*)"
              value={infos.url}
              required
              onChange={(e) => setInfos({ ...infos, url: e.target.value })}
            />
          </div>
        </div>
        <div className="w-full justify-content-end flex">
          <Button
            type="button"
            onClick={() => navigate(-1)}
            label="Trở về"
            className="ml-2"
            severity="secondary"
            size="small"
            outlined
          />
          {permissionTool.includes("/list_sheet/add") && (
            <Button
              type="submit"
              loading={loading}
              label={"Thêm mới"}
              className="ml-2"
              severity="info"
              size="small"
              raised
            />
          )}
        </div>
      </form>
    </div>
  );
};
export default AddSheet;
